(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    
window.addEventListener('load', function() {
  // Unbind any previous handlers (optional safeguard)
  jQuery('body').off('click', '.shopify_explorer_faq__question');

  // Bind the FAQ click handler and use event stopping to prevent duplicate toggles
  jQuery('body').on('click', '.shopify_explorer_faq__question', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    // Use nextAll() to get the answer element in case there are any extra nodes
    var $answer = jQuery(this).nextAll('.shopify_explorer_faq__answer').first();
    $answer.slideToggle(150);
    jQuery(this).toggleClass('active');
  });

  // OPTIONAL: If you don’t need the block select/deselect features, remove these:
  jQuery(document).off('shopify:block:select');
  jQuery(document).off('shopify:block:deselect');
});

  } catch(e) { console.error(e); }
})();
})();
